// extracted by mini-css-extract-plugin
export default {"appBar":"app-bar_appBar__1gquR"};